import React from "react";
import { inputClasses } from "./tailwindClassnames";

type TechnologySearchInputProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    // Both screens label the field for screen readers; the magnifier is
    // decorative and the input has no visible <label>.
    ariaLabel: string;
    id: string;
    testId: string;
};

// The search field above a technology grid: a magnifier and a full-width input.
// Shared so the Route wizard and the Connection screen present the same control
// instead of each carrying its own copy of the icon markup.
const TechnologySearchInput = ({
    value, onChange, placeholder, ariaLabel, id, testId,
}: TechnologySearchInputProps) => (
    <div className="relative w-full mt-4">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M11.4351 10.0629H10.7124L10.4563 9.81589C11.3528 8.77301 11.8925 7.4191 11.8925 5.94625C11.8925 2.66209 9.23042 0 5.94625 0C2.66209 0 0 2.66209 0 5.94625C0 9.23042 2.66209 11.8925 5.94625 11.8925C7.4191 11.8925 8.77301 11.3528 9.81589 10.4563L10.0629 10.7124V11.4351L14.6369 16L16 14.6369L11.4351 10.0629ZM5.94625 10.0629C3.66838 10.0629 1.82962 8.22413 1.82962 5.94625C1.82962 3.66838 3.66838 1.82962 5.94625 1.82962C8.22413 1.82962 10.0629 3.66838 10.0629 5.94625C10.0629 8.22413 8.22413 10.0629 5.94625 10.0629Z" fill="#8F8F8F"/>
            </svg>
        </span>
        <input
            id={id}
            placeholder={placeholder}
            aria-label={ariaLabel}
            data-testid={testId}
            value={value}
            className={inputClasses.standard + " w-full pl-9"}
            onChange={(e) => onChange(e.target.value)}
        />
    </div>
);

export default TechnologySearchInput;
